import { createContext, Dispatch } from "react";

export type Coachmark = {
    id: string;
    label: string;
    buttonLabel?: string;
    buttonOnClick?: () => void;
    tooltipMessage?: string;
};

export interface CoachmarksState {
    coachmarks: Coachmark[];
}

export const initialState: CoachmarksState = {
    coachmarks: [],
};

export type State = typeof initialState;

enum ActionTypes {
    Show,
    Hide,
}

function show(coachmark: Coachmark) {
    return {
        type: ActionTypes.Show as const,
        coachmark,
    };
}

function hide(id: string) {
    return {
        type: ActionTypes.Hide as const,
        id,
    };
}

export const actions = { show, hide };

type Actions = ReturnType<(typeof actions)[keyof typeof actions]>;
export type DispatchCoachmarks = Dispatch<Actions>;

export const StateContext = createContext<State>(initialState);
export const DispatchContext = createContext<DispatchCoachmarks | undefined>(undefined);

export function reducer(state: State, action: Actions): State {
    switch (action.type) {
        case ActionTypes.Show: {
            const { id } = action.coachmark;
            const existingIndex = state.coachmarks.findIndex((c) => c.id === id);

            // If exists, remove it first so we can add it to the end
            const filteredCoachmarks =
                existingIndex >= 0 ? state.coachmarks.filter((c) => c.id !== id) : state.coachmarks;

            return {
                coachmarks: [...filteredCoachmarks, action.coachmark],
            };
        }

        case ActionTypes.Hide: {
            return {
                coachmarks: state.coachmarks.filter((c) => c.id !== action.id),
            };
        }

        default: {
            throw new Error(`Unhandled action type`);
        }
    }
}
